<template>
  <div>
    <el-form-item
      for="school"
      label="Schule"
      prop="school"
    >
      <el-input
        id="school"
        v-model="form.school"
      />
    </el-form-item>

    <el-row :gutter="32">
      <el-col :sm="12">
        <el-form-item
          for="position"
          label="Funktion"
          prop="position"
        >
          <el-select
            id="position"
            v-model="form.position"
            placeholder="Bitte wählen"
          >
            <el-option
              v-for="(label, value) in $config.coacheePositions"
              :key="value"
              :label="label"
              :value="parseInt(value)"
            />
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :sm="12">
        <el-form-item
          for="school-type"
          label="Schulform"
          prop="schoolType"
        >
          <el-select
            id="school-type"
            v-model="form.schoolType"
            placeholder="Bitte wählen"
          >
            <el-option
              v-for="(label, value) in $config.coacheeSchoolTypes"
              :key="value"
              :label="label"
              :value="parseInt(value)"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'CAccountFormCoacheeSchool',

  props: {
    form: {
      type: Object,
      required: true
    }
  }
}
</script>
